<script>
    import  { resolveExportUrl } from "../../router.js";
    import wrappedFetch from "../../wrappedFetch.js";
    import { onMount } from "svelte";
    import Spinner from "../components/spinner.svelte";
    import Logs from "../components/logs.svelte";
    import { PageUrl } from "../../store.js";
    import NoDataFound from "../components/nodatainfo.svelte";

    export let providerId; 
    let isPageLoading = true;
    let logNumbers;
    let params;
    let titleProvider =  providerId == 1?"Google" :providerId == 3?"Microsoft":"";

    const getLogNumbers = async () => {
        isPageLoading = true;
        let resp = await wrappedFetch(
            `/api/cloudConfig/GetExportLogs?providerId=${providerId}`,
            { method: "post" }
        );
        logNumbers = (await resp.json()).result;
        
        if (logNumbers) {
            params={pupilsProcessed : logNumbers.processedPupils,
                    pupilsPending:logNumbers.pendingPupils,
                    pupilsErrors:0,
                    staffProcessed:logNumbers.processedStaff,
                    staffPending:logNumbers.pendingStaff,
                    staffErrors:0
        }
        }
        isPageLoading = false;
    };

    onMount( async () => {
        await getLogNumbers();
    });

</script>
<svelte:head>
<title> {titleProvider} Logs | Wavenet Nimbus </title>
</svelte:head>
{#if isPageLoading}
    <Spinner />
{:else}
{#if logNumbers == null}
<h1>Pending User Matches</h1>
<NoDataFound infoText="No Data Found">
    <p>Please ensure the configuration has been completed and data has been exported. Please click the 'Configuration' button below to view the settings.</p>
    <a class="btn btn-primary" href={resolveExportUrl(providerId,"/summary")}>Configuration</a>
</NoDataFound>

{:else}
    <Logs
    pupilLogsURL={resolveExportUrl(providerId,"/logs/pupil")} 
    staffLogsURL={resolveExportUrl(providerId,"/logs/staff")} 
        {params}
        parentComponent={"export"}
       >
        <div slot="header">
            <h1>Export Logs</h1>
        <p>Last export: {logNumbers.syncEndTimeStr}</p>
        </div>
    </Logs>
    {/if}
{/if}
